import React, { useState } from 'react'
import './CatalogPageHead.scss'
import { ReactComponent as BurgerIcon } from '../../components/assets/CatalogPage/BurgerCatalogPageHead.svg'
import { ReactComponent as CarIcon } from '../../components/assets/CatalogPage/CarCatalogPageHead.svg'
import { ReactComponent as ZoomIcon } from '../../components/assets/CatalogPage/ZoomIcon.svg'
import { useParams } from 'react-router'
import { catalogs } from '../../../constants/catalogs'

const CatalogPageHead = ({ setOpenFilter, setIsCartOpen, setFilters, filters }) => {
  const platform = useParams().platform
  const catalogPresonal = catalogs?.find((el) => el?.link === platform)

  return (
    <div className='CatalogPageHead'>
      <div className='Burger' onClick={() => setOpenFilter(true)}>
        <BurgerIcon />
      </div>
      <div className='Search'>
        <input
          type='text'
          className='Search__input'
          value={filters?.search}
          placeholder='Search...'
          onChange={(e) => {
            setFilters((prew) => ({ ...prew, search: e.target.value }))
          }}
        />
        <ZoomIcon />
      </div>
      <div className='Cart' onClick={() => setIsCartOpen(true)} style={catalogPresonal?.color ? { background: catalogPresonal?.color } : {}}>
        <CarIcon width={24} height={24} />
      </div>
    </div>
  )
}

export default CatalogPageHead
